import { render, staticRenderFns } from "./GiftsRecordDetail.vue?vue&type=template&id=a08e7160&scoped=true"
import script from "./GiftsRecordDetail.vue?vue&type=script&lang=js"
export * from "./GiftsRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./GiftsRecordDetail.vue?vue&type=style&index=0&id=a08e7160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08e7160",
  null
  
)

export default component.exports